import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { IStateList, ListComponent, TableCellSortable } from 'components/Abstract/List';
import Toolbar from 'components/Layout/Toolbar';
import FabButton from 'components/Shared/FabButton';
import TableWrapper from 'components/Shared/TableWrapper';
import { IEntity } from 'interfaces/entity';
import { IPaginationParams } from 'interfaces/pagination';
import PlusIcon from 'mdi-react/PlusIcon';
import RefreshIcon from 'mdi-react/RefreshIcon';
import React, { Fragment } from 'react';
import RxOp from 'rxjs-operators';
import entityService from 'services/entity';
import selectedVentureService from 'services/profile';

import EntityFormDialog from '../EntityFormDialog';
import ListItem from './ListItem';

interface IState extends IStateList<IEntity> {
  current?: IEntity;
  formOpened?: boolean;
  entities?: IEntity[];
}

export default class EntityListPage extends ListComponent<{}, IState> {
  constructor(props: {}) {
    super(props, 'level');
    this.state = {
      ...this.state,
      entities: [] as IEntity[],
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = (params: Partial<IPaginationParams> = {}) => {
    this.setState({ loading: true, error: null });
    selectedVentureService.getSelectedVenture().pipe(
      RxOp.logError(),
      RxOp.bindComponent(this),
    ).subscribe((selection) => {
      if (selection) {
        entityService.fetchEntitiesGraph(selection.id, { refresh: true });
        entityService.list(this.mergeParams(params))
          .pipe(RxOp.logError(), RxOp.bindComponent(this))
          .subscribe(
            (entities) => {
              this.setPaginatedData(entities);
            },
            error => this.setError(error)
          );
      }
    });
    entityService.refreshEntities();
  }

  onClickRefresh = () => this.loadData();

  handleCreate = () => {
    this.setState({ formOpened: true, current: null });
  }

  handleEdit = (current: IEntity) => {
    this.setState({ formOpened: true, current });
  }

  handleView = (current: IEntity) => {
    this.setState({ current });
  }

  formCallback = async (document?: IEntity) => {
    this.setState({ formOpened: false });
    entityService.refreshEntities();
    return this.state.current ?
      this.loadData() :
      this.handleChangeTerm(document.name);
  }

  formCancel = () => {
    this.setState({ formOpened: false });
  }

  render() {
    const { items, formOpened, loading, current, entities } = this.state;

    return (
      <Fragment>
        <Toolbar title='Módulos' breadcrumbs={[{ title: 'Configurações' }, { title: 'Módulos' }]} />
        <EntityFormDialog
          opened={formOpened || false}
          entity={current}
          onComplete={this.formCallback}
          onCancel={this.formCancel}
        />
        <Container>
          <Card>
            {this.renderLoader()}
            <CardContent>
              <Grid container justify="space-between">
                <Grid item xs sm={8} lg={4}>
                  {this.renderSearch()}
                </Grid>
                <Grid item xs='auto'>
                  <FabButton actions={[{
                    icon: PlusIcon,
                    onClick: this.handleCreate
                  }]} />
                </Grid>
                <Grid item xs={12}>
                  <TableWrapper minWidth={500}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCellSortable {...this.sortableProps} column='ventureName'>
                            Empreendimento
                          </TableCellSortable>
                          <TableCellSortable {...this.sortableProps} column='name'>
                            Nome
                          </TableCellSortable>
                          <TableCellSortable {...this.sortableProps} column='level'>
                            Nível
                          </TableCellSortable>
                          <TableCellSortable {...this.sortableProps} column='path'>
                            Caminho
                          </TableCellSortable>
                          <TableCell>
                            Ordem
                          </TableCell>
                          <TableCell>
                            <IconButton disabled={loading} onClick={this.onClickRefresh}>
                              <RefreshIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.renderEmptyAndErrorMessages(7)}
                        {Boolean(items && items.length) && items.map(entity =>
                          <ListItem
                            key={entity.id}
                            entities={entities}
                            entity={entity}
                            onEdit={this.handleEdit}
                            onShowHideComplete={this.loadData}
                            onDeleteComplete={this.loadData}
                          />
                        )}
                      </TableBody>
                    </Table>
                  </TableWrapper>
                  {this.renderTablePagination()}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
      </Fragment >
    );
  }
}
